<div class="container mt-4">
  <div class="row">
    <p class="col small text-secondary">POSH was created as a
      collaborative effort by the Sustaining Arctic Observing Networks
      initiative (SAON), the Arctic Portal, and the University of
      Colorado Boulder, with initial funding from the NOAA GOMO Arctic
      Research Program.  It harvests information from numerous site
      catalogs—such as AOV, DEIMS-SDR, SIOS, INTERACT, and ISAAFFIK—and
      is only updated if these sources are funded and maintained.</p>
  </div>
</div>
